import { Icon } from 'antd';

export const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1506110_ul8e0wdvhv.js'
  // scriptUrl: '//at.alicdn.com/t/font_1167113_ia8lzw48phe.js'
});
